import React from "react";
import { Skeleton, Stack } from "@mui/material";
import { SkeletonListCard, SkeletonDetailRows } from "../../../common/Utils/Skeleton/SkeletonComponents";

const PrescriptionListSkeleton = ({ count = 3 }) => (
  <SkeletonListCard
    count={count}
    listItemSx={{ alignItems: 'flex-start' }}
    renderItem={() => (
      <Stack sx={{ width: '100%' }} spacing={1}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Skeleton variant="text" width="50%" height={28} />
          <Skeleton variant="rounded" width={80} height={24} />
        </Stack>
        <SkeletonDetailRows widths={['35%', '40%']} />
      </Stack>
    )}
  />
);

export default PrescriptionListSkeleton;
